import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

// Every atelier call (key or admin): who / when / what.
export const AtelierAudit = ({ tick }) => {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/atelier/audit", { params: { limit: 100 } }).then(({ data }) => setRows(data)).catch(() => {}); }, [tick]);
  return (
    <section className="card-carbon min-w-0 space-y-3 rounded-2xl p-4" data-testid="atelier-audit">
      <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[var(--gold-bright)]"><ScrollText className="h-4 w-4" /> {t("atelier.audit")}</h2>
      <ul className="max-h-80 min-w-0 space-y-1 overflow-y-auto text-xs">
        {rows.map((r, i) => (
          <li key={`${r.at}-${i}`} className="flex min-w-0 flex-wrap gap-x-2 break-words text-neutral-300" dir="ltr" data-testid={`atelier-audit-${i}`}>
            <span className="text-neutral-500">{new Date(r.at).toLocaleString()}</span>
            <span className="font-semibold text-white">{r.actor}</span>
            <span className={r.status >= 400 ? "text-red-300" : "text-emerald-300"}>{r.action}</span>
            {r.method && <span>{r.method} {r.path}</span>}
            {r.status && <span>{r.status}</span>}
            {r.detail && <span className="text-neutral-500">{r.detail}</span>}
          </li>
        ))}
      </ul>
    </section>
  );
};
